import React from 'react';
import { Pagination, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { PaginationProps } from 'antd/lib/pagination';
import { CONSTANT } from '../../../../config/Constant';

interface DataType {
  key: string;
  id: string | any;
  uid: string | any;
  provider: string;
  provider_id: string;
  row_id: number;
  phone_number: string;
  time_updated: string;
}

const AddPortabilityNumberListTable: React.FC<any> = (props) => {
  const {
    listData,
    setListData,
    totalData,
    tableloading,
    setTableLoading,
    paginationData,
    setPaginationData,
    getAddPortNumberList,
    savePayload,
  } = props;

  const data: DataType[] = listData?.map((item, index) => ({
    key: index?.toString(),
    id: item?.index ?? index + 1,
    uid: item?._id,
    provider: item?.provider,
    provider_id: item?.provider_id,
    row_id: item?.row_id,
    phone_number: item?.phone_number,
    time_updated: item?.time_updated,
  }));

  const columns: ColumnsType<DataType> = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => a.id.toString().localeCompare(b.id),
    },
    {
      title: 'Provider',
      dataIndex: 'provider',
      key: 'provider',
      width: 200,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => (a.provider || '').localeCompare(b.provider || ''),
      render: (_, record) => {
        return record?.provider ? record?.provider : CONSTANT.NO_DATA_FOUND;
      },
      // fixed: 'left',
    },

    {
      title: 'Phone Number',
      dataIndex: 'phone_number',
      key: 'phone_number',
      // width: 180,
      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => (a.phone_number || '').localeCompare(b.phone_number || ''),
      render: (_, record) => {
        return record?.phone_number ? record?.phone_number : CONSTANT.NO_DATA_FOUND;
      },
    },

    {
      title: 'Created Date',
      dataIndex: 'time_updated',
      key: 'time_updated',
      // width: 180,

      sortDirections: ['descend', 'ascend'],
      sorter: (a, b) => (a.time_updated || '').localeCompare(b.time_updated || ''),
      render: (_, record) =>
        record?.time_updated
          ? record?.time_updated //dayjs(record?.step1_ack_code_date).format(CONSTANT.POST_DATE_TIME_FORMAT)
          : CONSTANT.NOT_UPDATED,
    },
  ];

  const handleChange: PaginationProps['onChange'] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      pageNumber: current,
      pageSize: page_size,
    };
    getAddPortNumberList(updateData);
  };

  const onShowSizeChange: PaginationProps['onShowSizeChange'] = (current, page_size) => {
    setListData([]);
    setTableLoading(true);
    setPaginationData({
      current: current,
      page_size: page_size,
    });
    const updateData = {
      ...savePayload,
      pageNumber: current,
      pageSize: page_size,
    };
    getAddPortNumberList(updateData);
  };

  return (
    <>
      <div className="responsiveTable">
        <Table
          dataSource={data}
          columns={columns}
          pagination={false}
          loading={tableloading}
          bordered
          size="small"
          scroll={{ x: 1000, y: 400 }}
          rowHoverable={true}
          tableLayout={'fixed'}
        />
      </div>
      <div className="text-center mt-20 mb-30">
        <Pagination
          defaultCurrent={1}
          current={paginationData?.current}
          total={totalData ?? 0}
          onChange={handleChange}
          responsive={true}
          pageSize={paginationData?.page_size ?? 10}
          showSizeChanger={totalData ? true : false}
          onShowSizeChange={onShowSizeChange}
          pageSizeOptions={CONSTANT.PER_PAGE_RECORD}
        />
      </div>
    </>
  );
};
export default AddPortabilityNumberListTable;
